import {actionGroupTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = actionGroupTypes;

const path = `iot/action-group`;

const base = new BaseAction(types);

export const getActionGroupDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedActionGroupDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getActionGroupData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedActionGroupData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addActionGroupData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editActionGroupData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteActionGroupData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreActionGroupData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteActionGroupData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
